/**
 *  @author Eugene Terentev <eugene@terentev.net>
 */



// WEBPACK FOOTER //
// ./frontend/web/js/app.js